export default __webpack_public_path__ + "5fe87d8745c924786949239ba64ae9e8.png";